import React from 'react';
import {imageUrl} from 'helpers/ApplicationHelper';

const stepPreview = (props) => {
    return (
    <div className={"step-preview" + (props.stepReverseMobile ? ' reverse' :'')}>
        <div className="step-img-container">
            <img className="step-img" src={imageUrl(`${props.stepImg}`)} alt=""/>
        </div>
        <div className="step-desc">
            <span className="step-num">{props.stepNum}</span>
            <hr/>
            <span className="step-text" dangerouslySetInnerHTML={ {__html: props.stepDesc}}/>
        </div>
    </div>
    );
}   

export default stepPreview;